export function reactOnErrorMessage(component, {
    errorField = "errorMessage",
    errorMessageGetter = state => state[errorField],
    errorClass = "invalid",
    addTitle = true
} = {}) {
    component.onStatePropertyChanged(errorField, newValue => {
        if (newValue) {
            if (addTitle) {
                component.$el.attr("title", errorMessageGetter(component.state));
            }
            component.$el.addClass(errorClass);
        } else {
            if (addTitle) {
                component.$el.removeAttr("title");
            }
            component.$el.removeClass(errorClass);
        }
    });
}


// WEBPACK FOOTER //
// ./web/js/components/validation/utils.js